const routes = {
  home: '/',
  account: '/account',
  feedback: '/feedback',
  exportData: '/export',
  newTeam: '/new',
  personnelSearch: '/personnel',
  personnel: '/personnel/:userId',
  roster: '/roster',
  teamSettings: '/settings',
  allTeams: '/teams',
  teamRoster: '/teams/:teamId',
  editTeam: '/teams/:teamId/manage',
  dailyRoster: '/today',
};

/**
 * Generates a working route from a route with path parameters.
 * E.g. /teams/:teamId is replaced with /teams/team-uuid-1234.
 * Currently works to substitute single path parameter.
 * @param route the base route that has path parameter.
 * @param parameter parameter name to be substituted.
 * @param value value to substitute the parameter name.
 * @returns a working route with path parameter replaced.
 */
export const routesWithPathParameter = (
  route: string,
  parameter: string,
  value: string
) => {
  if (parameter === '') {
    return route;
  }
  return route.replace(`:${parameter}`, value);
};

export default routes;
